import { History } from "history";
import { FC, ReactElement, useLayoutEffect, useState } from "react";
import { Route, Router, Routes } from "react-router-dom";
import history from "../router/history";
import { AppPages } from "./types";
import { NotFoundPage } from "./containers/NotFound";
import { Home } from "./containers/Home";
import { ExceededRequest } from "./containers/ExceededRequest/Loadable";
import { SuccessfulRequest } from "./containers/SuccessfulRequest/Loadable";
import PublicTestConfirmationCard from "./containers/Confirm/PublicTestConfirmationCard";
interface CustomRouterProps {
  history: History;
  children?: ReactElement;
}

const CustomRouter: FC<CustomRouterProps> = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

function App() {
  return (
    <>
      <CustomRouter history={history}>
        <Routes>
          <Route path={AppPages.HomePage} element={<Home />} />
          <Route path={AppPages.LoginCallback} element={<Home />} />
          <Route path={AppPages.NotFoundPage} element={<NotFoundPage />} />
          <Route path={AppPages.Exceeded} element={<ExceededRequest />} />
          <Route
            path={AppPages.ConfirmPublicTest}
            element={<PublicTestConfirmationCard />}
          />
          <Route
            path={AppPages.SuccessfulRequest}
            element={<SuccessfulRequest />}
          />
        </Routes>
      </CustomRouter>
    </>
  );
}

export default App;
